import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.facet.accentBlue21,
  },
});

const OnboardingNavigatorPreviousButton = ({
  className,
  classes,
  onClick,
  disabled,
  ...rest
}) => {
  return (
    <IconButton
      onClick={onClick}
      className={classNames(classes.root, className)}
      aria-label={'go back button'}
      title={'Go Back'}
      color={'primary'}
      icon={NavigateBeforeIcon}
      size={'large'}
      disabled={disabled}
      test={'onboarding-navigator-back-button'}
      {...rest}
    />
  );
};

OnboardingNavigatorPreviousButton.defaultProps = {
  className: '',
  disabled: false,
};

OnboardingNavigatorPreviousButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(OnboardingNavigatorPreviousButton);
